module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Hummer-894858f559c27f114ccb948c955eda40.svg";